import React from 'react';
import { StylesProvider } from '@material-ui/core/styles';

// see https://material-ui.com/styles/advanced/#css-injection-order
// added to use emotion to pass classes props to material-ui components
// @review does it work with SSR? should I integrate it to @whys/app plugin?
export function MuiInjectFirst(props: { children: React.ReactNode }) {
  return <StylesProvider injectFirst>{props.children}</StylesProvider>;
}
